module.exports = "/_next/static/images/Introduction@2x-8118e3aeb6a746d203d1b2fa2e75d2e2.png";